import {Option} from 'platform/components';

import {isNotNil} from 'ramda';

import {SupplierOrderType} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

/**
 * Builds select options from supplier order types, dropping any entry without a usable
 * value or label. The backend may return order types with a `null` value (e.g. for invalid
 * supplier/variant combinations); such entries must not be selectable.
 */
export const getOptionsFromSupplierOrderTypes = (
  supplierOrderTypes: SupplierOrderType[] | Nullish
): Option[] =>
  (supplierOrderTypes ?? []).reduce<Option[]>((options, orderType) => {
    if (isNotNil(orderType.value) && isNotNil(orderType.label)) {
      options.push({label: orderType.label, value: orderType.value});
    }

    return options;
  }, []);
